import React /* , { useState } */ from 'react';
import { formatDate } from '../../../utils/date';

function ShareDocumentsElement(props) {
	// const [showDocument, setShowDocument] = useState(false);

	return (
		<>
			<div className="sd-element-container" id={props.id}>
				<div className="sd-element-data">
					<div className="sd-element-name">
						<span className="sd-data-title">{props.data?.name}</span>
					</div>
					<div className="sd-element-name">
						<span className="sd-data-title">
							{formatDate(props.data?.uploadDate, 'DD.MM.YYYY')}
						</span>
					</div>
					<div className="icon-containers">
						{/* <div
							className="sd-detail-icon"
							onClick={() => setShowDocument(true)}
						></div> */}
						<div
							className="trash-icon"
							onClick={() => props.onDeleteItem(props.data.id)}
						></div>
					</div>
				</div>
				{/* <div className="sd-element-details-open">
					{showDocument && (
						<div className="sd-modal" onClick={() => setShowDocument(false)}>
							<iframe
								id="inlineFrameDocument"
								title="Inline Frame Document"
								width="300"
								height="200"
								src="https://api.continentaledison.fr/upload/CEHUPC21_IM_FR_062015_V1.pdf"
							></iframe>
						</div>
					)}
				</div> */}
			</div>
		</>
	);
}

export default ShareDocumentsElement;
